export default {
    appName: process.env.REACT_APP_APP_NAME,
    apiURL: process.env.REACT_APP_API_URL,
    tokenKey: process.env.REACT_APP_TOKEN_KEY,
    stripeKey: process.env.REACT_APP_STRIPE_KEY,
}